var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.store.open)?_c('div',{staticClass:"toast",class:[_vm.store.position],style:(_vm.store.style)},[_vm._v(" "+_vm._s(_vm.store.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }